// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookies from 'vue-cookies'
import App from './App'
import router from './router'
import store from './store'
import BrizeFilter from '@/common/brize.filter'
import DateFilter from '@/common/date.filter'
import ShippingUuid from '@/common/shippingUuid.filter'
import CleanUpHtml from '@/common/cleanUpHtml.filter'
import CurrencyFilter from '@/common/currency.filter'
import PhoneFormattingFilter from '@/common/phoneFormatting.filter'
import BootstrapVue from 'bootstrap-vue'

import titleMixin from '@/common/titleMixin'
Vue.mixin(titleMixin)

import UtilsMixin from '@/mixins/utils.mixin'
Vue.mixin(UtilsMixin)

import FetchesMixin from '@/mixins/fetches.mixin'
Vue.mixin(FetchesMixin)

import { Icon } from 'leaflet'
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserPlus, faUsersCog, faUser, faUserCog, faSignOutAlt, faBookmark, faTrashAlt, faPhone, faCheck, faArrowAltCircleLeft, faEdit, faMapMarkerAlt, faMapMarkedAlt, faBolt, faExclamationTriangle, faDownload, faFilePdf, faSyncAlt, faLifeRing, faStore, faPlus, faPen, faCog, faCircle, faQuestionCircle, faPrint, faEnvelope, faCrosshairs, faVideo, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import { faBookmark as farBookmark, faClock, faCopy, faCalendarAlt, faImage, faEye, faDotCircle, faCheckCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import GetTextPlugin from 'vue-gettext'
import translations from './translations.json'
import appConfig from '@/config.js'
import * as moment from 'moment-timezone'

Vue.prototype.moment = moment

Vue.prototype.$appConfig = appConfig

library.add(faUserPlus, faUsersCog, faUser, faUserCog, faSignOutAlt, faBookmark, faTrashAlt, faPhone, faCheck, faArrowAltCircleLeft, faEdit, faMapMarkerAlt, faMapMarkedAlt, faBolt, faExclamationTriangle, faDownload, faFilePdf, faSyncAlt, faLifeRing, faStore, faPlus, faPen, faCog, faCircle, faQuestionCircle, faPrint, faEnvelope, faCrosshairs, faVideo, faExternalLinkAlt, farBookmark, faClock, faCopy, faCalendarAlt, faImage, faEye, faDotCircle, faCheckCircle, faTimesCircle)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

// vendors CSS
require('@/assets/scss/vendors.scss')

Vue.config.productionTip = true

Vue.filter('brize', BrizeFilter)
Vue.filter('date', DateFilter)
Vue.filter('uuid', ShippingUuid)
Vue.filter('cleanUpHtml', CleanUpHtml)
Vue.filter('currency', CurrencyFilter)
Vue.filter('phone', PhoneFormattingFilter)

Vue.use(VueResource)
Vue.use(VueCookies, {path: '/'})
Vue.use(BootstrapVue)

const inputFacadeOptions = {
  // use these tokens instead of the default
  tokens: {
    '#': { pattern: /\d/ },
    X: { pattern: /[0-9a-zñ]/i, transform: (v) => v.toLocaleUpperCase() },
    x: { pattern: /[0-9a-zñ]/i, transform: (v) => v.toLocaleLowerCase() },
    S: { pattern: /[a-zñ]/i },
    A: { pattern: /[a-zñ]/i, transform: (v) => v.toLocaleUpperCase() },
    a: { pattern: /[a-zñ]/i, transform: (v) => v.toLocaleLowerCase() },
    '\\': { escape: true },
    '?': { optional: true },
    '*': { repeat: true },
    '|': { pipe: true }
  }
}
import InputFacade from 'vue-input-facade'
Vue.use(InputFacade, inputFacadeOptions)

import VueHtmlToPaper from 'vue-html-to-paper'

const options = {
  name: '_blank',
  specs: [
    'fullscreen=no',
    'titlebar=no',
    'scrollbars=no',
    'menubar=no',
    'location=no'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css'
  ]
}

Vue.use(VueHtmlToPaper, options)

Vue.http.interceptors.push((req, next) => {
  // Add eco header if it's an API req and there is eid
  if (req.url.includes(appConfig.api.baseUrl) && window.localStorage.getItem('eid')) {
    req.headers.set('x-moova-ecosystem-id', window.localStorage.getItem('eid') + '')
  }
})

Vue.http.interceptors.push((req, next) => {
  next(res => {
    let obj
    if (moovaDashboard && res.status > 401 && res.status <= 500) {
      let message = ''
      if (res.status === 422 && res.body.errors) {
        for (let i = 0; i < res.body.errors.length; i++) {
          message += '- ' + res.body.errors[i].detail + '<br>'
        }
      } else {
        message = res.body.message
      }
      obj = {
        title: 'ERROR',
        message: message,
        type: 'error'
      }
      console.log('%cStatus ' + res.status + '\n"' + obj.message + '" on:\n' + res.url, 'padding: 5px; background: #f00; color: #cf0;font-size: 1.5em; font-weight: bold;')
      moovaDashboard.$root.$children[0].$refs.simplert.openSimplert(obj)
    } else if (res.status === 0 && res.url.indexOf('couriers-summary') === -1) {
      obj = {
        title: 'ERROR',
        message: '<h1>SERVER error :/</h1>',
        type: 'error'
      }
      moovaDashboard.$root.$children[0].$refs.simplert.openSimplert(obj)
    }
  })
})

console.log('%c( ͡° ͜ʖ ͡°) for code, uh?', 'font-size: 1.2em; font-weight: bold;')
console.log('%cU ' + '%c♥' + '%c‿' + '%c♥ ' + '%cVue.js' + '%c?', 'font-size: 1.2em;', 'font-size: 1.2em; color: red', 'font-size: 1.2em;', 'font-size: 1.2em; color: red;', 'font-size: 1.2em; font-weight: bold;', 'font-size: 1.2em;')
console.log('%c(づ｡◕‿‿◕｡)づ ' + '%cSCSS' + '%c?', 'font-size: 1.2em;', 'font-size: 1.2em; font-weight: bold;', 'font-size: 1.2em;')
console.log('%cDone with that sad and empty (・3・) selfie life?', 'color: #999;')
console.log('%cDon\'t be ' + '%c=' + '%c^_^' + '%c=', 'font-size: 1.2em;', 'font-size: 1.2em; color: red', 'font-size: 1.2em;', 'font-size: 1.2em; color: red')
console.log('%cGet in touch at nico@moova.io! ', 'padding: 5px; background: #000; color: #cf0;font-size: 2em; font-weight: bold;')
console.log('%cWe will talk ' + '%cツ ', 'padding: 5px; background: #000; color: #0ff;font-size: 2em; font-weight: bold;', 'padding: 5px; background: #000; color: #fff;font-size: 2em; font-weight: bold;')
console.log('%c| (• ◡•)| and (❍ᴥ❍ʋ) will be ᕕ( ᐛ )ᕗ', 'font-size: 1.2em;')

if (appConfig.debug !== true) {
  window.console.log = function () {}
}

let moovaDashboard

function getCookie(name) {
  let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}

async function fetchEcosystem() {
  const hostname = window.location.hostname.replace('dashboard.', '').replace('backoffice.', '').replace('gcm2.', '').replace('gcm.', '')
  return await Vue.http.get(appConfig.api.baseUrl + 'ecosystems/by-hostname', { params: {hostname, fields: 'id,front_config'} })
    .then(response => {
      Vue.prototype.$universe = response.body.front_config && response.body.front_config.universe ? response.body.front_config.universe : {
        siteName: 'Moova',
        logo: '/static/img/moova.svg',
        logoLogin: '/static/img/moova-blue.svg',
        theme: 'moova',
        helpUrl: 'http://ayuda.moova.io/',
        helpEmail: 'help@moova.io',
        salesEmail: 'comercial@moova.io',
        googleRegister: true,
        terms: 'https://moova.io/terminos-y-condiciones/',
        privacy: 'https://moova.io/politica-de-privacidad/'
      }

      if (response.body.front_config?.integrations) {
        appConfig.integrations = {...appConfig.integrations, ...response.body.front_config.integrations}
      }

      store.dispatch('setUniverse', Vue.prototype.$universe)
      Vue.prototype.$eid = response.body.id
      store.dispatch('setEid', Vue.prototype.$eid)
      Vue.prototype.$ename = response.body.name
    }, e => {
      console.log(e)
      Vue.prototype.$universe = {
        siteName: 'Moova',
        logo: '/static/img/moova.svg',
        logoLogin: '/static/img/moova-blue.svg',
        theme: 'moova',
        helpUrl: 'http://ayuda.moova.io/',
        helpEmail: 'help@moova.io',
        salesEmail: 'comercial@moova.io',
        googleRegister: true,
        terms: 'https://moova.io/terminos-y-condiciones/',
        privacy: 'https://moova.io/politica-de-privacidad/'
      }
      store.dispatch('setUniverse', Vue.prototype.$universe)
      Vue.prototype.$eid = 1
      store.dispatch('setEid', Vue.prototype.$eid)
      Vue.prototype.$ename = 'Moova'
    })
    .then(async () => {
      return await fetchCountries(Vue.prototype.$eid)
    })
}

// Get all active countries
async function fetchCountries(eid = 1) {
  const countryParams = {
    includes: [
      'notification_configs'
    ],
    filter_groups: [
      {
        filters: [
          ['ecosystem_id', 'eq', eid]
        ]
      }
    ]
  }
  return await Vue.http.get(appConfig.api.baseUrl + 'countries', { params: countryParams })
    .then(response => {
      window.countries = response.body.data
      if (Vue.prototype.$eid === 1) {
        let index = response.body.data.findIndex(x => x && x.front_config && x.front_config.universe && x.front_config.universe.domain === window.location.hostname)
        Vue.prototype.$frontConfig = index !== -1 ? window.countries[index].front_config : null
        if (Vue.prototype.$frontConfig && Vue.prototype.$frontConfig.universe && Vue.prototype.$frontConfig.universe.restrictRegisterToCountry) {
          document.cookie = 'country=' + window.countries[index].iso_code.toUpperCase() + ';path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
          window.country = window.countries[index].iso_code.toUpperCase()
          document.cookie = 'phonePrefix=' + Vue.prototype.$frontConfig.i18n.phonePrefix + ';path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
          window.phonePrefix = Vue.prototype.$frontConfig.i18n.phonePrefix
        }
      } else {
        let index = 0
        Vue.prototype.$frontConfig = window.countries[index].front_config
        if (Vue.prototype.$frontConfig && Vue.prototype.$universe) {
          document.cookie = 'country=' + window.countries[index].iso_code.toUpperCase() + ';path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
          window.country = window.countries[index].iso_code.toUpperCase()
          document.cookie = 'phonePrefix=' + Vue.prototype.$frontConfig.i18n.phonePrefix + ';path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
          window.phonePrefix = Vue.prototype.$frontConfig.i18n.phonePrefix
        }
      }
      return response
    })
}

// Get user country
Vue.http.get(appConfig.geo.check, {headers: { 'Authorization': 'Basic ' + window.btoa(appConfig.geo.account + ':' + appConfig.geo.key) }}).then(response => {
  if (!getCookie('country')) {
    document.cookie = 'country=' + response.body.country.iso_code.toUpperCase() + ';path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
    window.country = response.body.country.iso_code.toUpperCase()
    document.cookie = 'phonePrefix=;path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
    window.phonePrefix = ''
  } else {
    window.country = window.country || getCookie('country')
  }
}).catch(e => { // On FAIL set AR as default
  document.cookie = 'country=AR;path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
  window.country = 'AR'
  document.cookie = 'phonePrefix=54;path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
  window.phonePrefix = '54'
}).then(() => {
  // Fetch the ecosystem and set all active countries
  fetchEcosystem()
    .then(response => {
      // Set country list
      window.countries = response.body.data
      // Set global frontend config
      let preFrontConfig = Vue.prototype.$frontConfig
      Vue.prototype.$universe = preFrontConfig ? preFrontConfig.universe || null : null
      if (preFrontConfig && preFrontConfig.universe && preFrontConfig.universe.restrictRegisterToCountry) {
        Vue.prototype.$frontConfig = preFrontConfig
      } else {
        Vue.prototype.$frontConfig = response.body.data.findIndex(x => x.iso_code === window.country) !== -1 ? response.body.data.find(x => x.iso_code === window.country).front_config : null
      }
      if (Vue.prototype.$frontConfig) {
        if (preFrontConfig && preFrontConfig.universe) {
          Vue.prototype.$universe = preFrontConfig.universe
        }
        // Set global TZ (fallback to UTC)
        Vue.prototype.$frontConfig.i18n.tz = Vue.prototype.$tz = getCookie('bypassCountry') || !Vue.prototype.$frontConfig.i18n.tz ? 'UTC' : Vue.prototype.$frontConfig.i18n.tz
      } else {
        // Extreme fallback
        Vue.prototype.$tz = 'UTC'
      }

      // Set default GetTextPlugin
      Vue.use(GetTextPlugin, {
        translations: translations,
        defaultLanguage: 'es_AR',
        silent: true,
        availableLanguages: {
          en_US: 'English',
          es_AR_iflow: 'Español de Argentina (iFLOW)',
          es_AR: 'Español de Argentina',
          es_BO_kinggo: 'Español de Bolivia (King Go)',
          es_CL: 'Español de Chile',
          es_CL_bluex: 'Español de Chile (Blue Express)',
          es_UY: 'Español de Uruguay',
          es_GT: 'Español de Guatemala',
          es_MX: 'Español de México',
          es_PA: 'Español de Panamá',
          es_CR: 'Español de Costa Rica',
          es_PE: 'Español de Perú',
          es_CO: 'Español de Colombia',
          es_ES: 'Español de España'
        }
      })

      // Set GoogleMap locale
      // Vue.use(VueGoogleMaps, {
      //   load: {
      //     key: appConfig.maps.api_key,
      //     libraries: 'places',
      //     language: response.body.data.findIndex(x => x.iso_code === window.country) !== -1 ? response.body.data.find(x => x.iso_code === window.country).front_config.i18n.gMaps : 'en'
      //   }
      // })

      window.phoneFormattersFile = require('../node_modules/cleave.js/dist/addons/cleave-phone.i18n.js')

      /* eslint-disable no-new */
      moovaDashboard = new Vue({
        el: '#app',
        router,
        store,
        template: '<App/>',
        components: { App }
      })
    })
})
